import { getEnv } from "./env";

// src/utils/feegow-api.ts
export class FeegowApi {
  /**
   * Get the Feegow API URL for the current environment
   */
  static getFeegowApiUrl(): {
    url: string;
  } {
    if (window.location.hostname.includes("localhost")) {
      return { url: "http://localhost:8000" };
    }
    if (window.location.hostname.includes("staging")) {
      return {
        url: getEnv(
          "VUE_APP_CORE_API_URL",
          "https://core.staging.feegow.com"
        ) as string,
      };
    }
    if (
      ["dev", "milestone"].some(function (p) {
        return window.location.hostname.includes(p);
      })
    ) {
      return { url: "https://core-dev.feegow.com" };
    }
    return {
      url: getEnv("VUE_APP_CORE_API_URL", "https://core.feegow.com") as string,
    };
  }

  /**
   * Fetch data from the Feegow API
   * @param method HTTP method
   * @param route API route
   * @param body
   */
  static async fetch(
    method: string,
    route: string,
    body?: any,
    returnType?: string
  ): Promise<any> {
    return await FeegowApi.fetchBase(method, route, body, returnType);
  }

  static async fetchForm(
    method: string,
    route: string,
    body?: any,
    returnType?: string
  ): Promise<any> {
    return await FeegowApi.fetchBase(
      method,
      route,
      body,
      returnType,
      "application/x-www-form-urlencoded"
    );
  }

  static async fetchBase(
    method: string,
    route: string,
    body?: any,
    returnType?: string,
    contentType = "application/json"
  ): Promise<any> {
    const { url: apiUrl } = FeegowApi.getFeegowApiUrl();
    const token = sessionStorage.getItem("tk") ?? localStorage.getItem("tk");
    const requestHeaders = {
      "Content-Type": contentType,
      ...(token ? { "x-access-token": token } : {}),
    };

    const formBody: string[] = [];
    for (const property in body) {
      const encodedKey = encodeURIComponent(property);
      const encodedValue = encodeURIComponent(body[property]);
      formBody.push(`${encodedKey}=${encodedValue}`);
    }
    const bodyString = formBody.join("&");

    let queryParam = "";
    if (bodyString && method === "GET") {
      queryParam = `?${bodyString}`;
    }

    const finalBody =
      contentType === "application/x-www-form-urlencoded"
        ? bodyString
        : JSON.stringify(body);

    const options =
      method === "GET"
        ? { method, headers: requestHeaders }
        : { method, headers: requestHeaders, body: finalBody };

    const response = await fetch(`${apiUrl}${route}${queryParam}`, options);

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw { status: response.status, data: errorData };
    }

    if (returnType == "text") {
      return await response.text();
    }

    return await response.json();
  }

  static fetchBeacon(route: string, body: any): void {
    const { url: apiUrl } = FeegowApi.getFeegowApiUrl();
    const token = sessionStorage.getItem("tk") ?? localStorage.getItem("tk");

    const payload = {
      ...(body || {}),
      ...(token ? { "x-access-token": token } : {}),
    };

    const blob = new Blob([JSON.stringify(payload)], {
      type: "application/json",
    });

    navigator.sendBeacon(`${apiUrl}${route}`, blob);
  }
}
